import { Box, Chip as MuiChip, Skeleton, Tooltip } from "@mui/material";
import React from "react";
import { Color, GetColorPicker } from "../colorPicker/ColorPicker.types";
import { useChipStyles } from "./Chip.styles";

export interface ChipProps {
    value: string;
    id?: string;
    isSelected?: boolean;
    onClick?: (id: string) => void;
    size?: "medium" | "small" | undefined;
    color?: Color;
    onDelete?: (event: any) => void;
    deletionIcon?: any;
    isAutocomplete?: boolean;
    disabled?: boolean;
    isLoading?: boolean;
    collapse?: boolean;
    alternativeColor?: { backgroundColor: string; color: string };
    textSize?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
    fontStyle?: "italic";
    hoverText?: string | React.ReactNode;
    variant?: "outlined" | "filled";
}

function Chip(props: ChipProps) {
    const styles = useChipStyles(GetColorPicker(props.color?.toString()), props);
    const onClickEnabled = props.onClick && !props.disabled;
    const onChipClick = () => {
        if (onClickEnabled) {
            props.onClick!(props.id!);
        }
    };
    const height = props.isAutocomplete ? 21 : props.size === "small" ? 24 : 32;
    const chipStyle = props.color === undefined ? styles.chip : styles.chipColored;
    const collapseWidth = 25;
    const getChip = () => {
        return (
            <Box sx={{ lineHeight: "normal", "&:hover": { cursor: onClickEnabled ? "pointer" : "unset" } }} onClick={() => onChipClick()}>
                <MuiChip
                    sx={{
                        ...chipStyle,
                        width: props.collapse ? collapseWidth : "auto",
                        fontStyle: props.fontStyle ?? "inherit",
                        height: height,
                    }}
                    disabled={props.disabled}
                    onDelete={props.onDelete !== undefined ? (event) => props.onDelete!(event) : undefined}
                    deleteIcon={props.deletionIcon}
                    label={props.collapse ? "" : props.value}
                    variant={props.variant}
                />
            </Box>
        );
    };

    return (
        <>
            {props.isLoading ? (
                <Skeleton variant="rounded" height={height} width={props.collapse ? collapseWidth : 100} />
            ) : props.collapse ? (
                <Tooltip title={props.value}>{getChip()}</Tooltip>
            ) : props.hoverText ? (
                <Tooltip title={props.hoverText}>{getChip()}</Tooltip>
            ) : (
                getChip()
            )}
        </>
    );
}

export default Chip;
